import { ComposantSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ComposantModel: SelectorModel = {
  name: 'composants',
  getSelector: ComposantSelectors.selectAllComposantsDictionary,
  isReady: ComposantSelectors.selectIsReadyComposant
};
